import React, { useContext, useState } from "react";
import { PatentContext } from "../../context/PatentContextProvider";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";

export const PatentLicensingModal = () => {
    const { register, formState: { errors }, watch, handleSubmit, reset } = useForm({ mode: "onBlur" });
    const watchedData = watch();
    const { patentLicensingModal, setPatentLicensingModal } = useContext(PatentContext);
    const onSubmit = async (data) => {
        try {
            const { email, Name, contactNo, patentNo } = data;
            const endpoint = `${process.env.REACT_APP_API_PATH}/patentLicensing`;
            const response = await axios.post(endpoint, {
                email,
                Name,
                contactNo,
                patentNo,
            });
            if (response.status === 201) {
                reset();
                toast.success("Your request has been successfully submitted!")
                setPatentLicensingModal(false);
            }
        } catch (error) {
            console.error('Error submitting data:', error);
        }
    };

    return (
        <>
            {patentLicensingModal && (
                <div className="bg-gray-100 flex items-center justify-center ">
                    {/* Modal */}
                    {patentLicensingModal && (
                        <div
                            className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-start justify-center z-50 pt-20"
                            onClick={(e) => {
                                // Close modal if clicked outside the modal container
                                if (e.target.id === "modalOverlay") setPatentLicensingModal(false);
                            }}
                            id="modalOverlay"
                        >
                            {/* Modal Container */}
                            <div className="bg-white rounded-lg shadow-lg w-[90%] sm:w-2/3 md:w-1/2 lg:w-1/3 p-4 sm:p-6 relative max-h-[90vh] overflow-y-auto">
                                <button
                                    onClick={() => {
                                        setPatentLicensingModal(false);

                                    }}
                                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none"
                                >
                                    ✖
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="mb-4">
                                        <h2 className="text-xl font-semibold text-gray-800 overflow-auto">
                                            Marketing and licensing of Patents
                                        </h2>
                                    </div>
                                    {/* Modal Body */}
                                    <div class="mb-6">
                                        <label
                                            for="Name"
                                            class="block mb-2 text-sm font-medium text-gray-900"
                                        >
                                            Name
                                        </label>
                                        <input
                                            type="text"
                                            name="Name"
                                            id="Name"
                                            class="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
                                            {...register("Name", {
                                                required: "Name is required",
                                            })}
                                            placeholder="Enter Name"
                                        />
                                        {errors.Name && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                    paddingTop: "5px",
                                                }}
                                            >
                                                {errors.Name.message}
                                            </small>
                                        )}
                                    </div>
                                    <div class="mb-6">
                                        <label
                                            for="email"
                                            class="block mb-2 text-sm font-medium text-gray-900 "
                                        >
                                            Email
                                        </label>
                                        <input
                                            type="text"
                                            name="email"
                                            id="email"
                                            class="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                                            {...register("email", {
                                                required: "Email is required",
                                                validate: {
                                                    maxLength: (v) =>
                                                        v.length <= 50 ||
                                                        "The email should have at most 50 characters",
                                                    matchPattern: (v) =>
                                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                                            v
                                                        ) || "email address must be a valid address",
                                                },
                                            })}
                                            placeholder="Enter Email"
                                        />
                                        {errors.email && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                }}
                                            >
                                                {errors.email.message}
                                            </small>
                                        )}
                                    </div>
                                    <div class="mb-6">
                                        <label
                                            for="patent_number"
                                            class="block mb-2 text-sm font-medium text-gray-900 "
                                        >
                                            Phone number
                                        </label>
                                        <input
                                            type="text"
                                            name="contactNo"
                                            id="contactNo"
                                            className="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            {...register("contactNo", {
                                                required: "Phone number is required",
                                                validate: {
                                                    isNumeric: (v) =>
                                                        /^\d{8}$/.test(v) ||
                                                        "Phone number must be exactly 8 digits",
                                                },
                                            })}
                                            maxLength={8}
                                            placeholder="Enter Phone Number"
                                        />
                                        {errors.contactNo && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                }}
                                            >
                                                {errors.contactNo.message}
                                            </small>
                                        )}
                                    </div>
                                    <div className="mb-4">
                                        <label
                                            htmlFor="bussiness-solution"
                                            className="block text-sm font-medium text-gray-700 mb-2"
                                        >
                                            Patent's number
                                        </label>
                                        <textarea
                                            type="text"
                                            id="Patentnumber..."
                                            name="patentNo"
                                            className="bg-gray-50 border border-gray-600 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
                                            {...register("patentNo", {
                                                required: "Patent's is required",
                                            })}
                                            placeholder="Patent's number..."
                                        />
                                        {errors.patentNo && (
                                            <small
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    display: "block",
                                                    paddingTop: "5px",
                                                }}
                                            >
                                                {errors.patentNo.message}
                                            </small>
                                        )}
                                    </div>
                                    {/* Modal Footer */}
                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            className="px-4 py-2 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        >
                                            Send
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    )
}